import './styles/common.css';
import './styles/grapheditor.css';
import {EditorUi} from './EditorUi';
import {fromWorkflowDefinition, newWorkflow} from './workflow';
import {Editor} from './Editor';
import {api} from '../Common/fetchWithTimeout';
import isEmpty from 'lodash/isEmpty';
import 'fomantic-ui-less/definitions/modules/dropdown';
import {workflowRun} from '../Common/workflowRun';

const loadGraphEditor = (graphContainer, workflow, currentWorkflowDefinition, editable = true, fullMode = true) => {
    const editorUi = new EditorUi(new Editor(editable), graphContainer, currentWorkflowDefinition, fullMode);
    editorUi.editor.initializeWorkflow(workflow);
    editorUi.actions.get('save').setEnabled(false);

    const refreshOnClick = document.getElementById('graph-refresh-on-click');
    if (refreshOnClick && refreshOnClick instanceof HTMLDetailsElement) {
        refreshOnClick.addEventListener('toggle', e => editorUi.actions.get('resetView').funct(e));
    }

    if (!fullMode) {
      editorUi.actions.get('resetView').funct();
    }

    return editorUi;
}

const enableButtons = (target, editorUi, currentWorkflowDefinition, closable = true, disabled = false) => {
  if (editorUi.editor.editable) {
        target.insertAdjacentHTML('afterend', `
                <div class="ui bottom fixed small borderless menu page-footer">
                    <div class="right menu">
                        <div class="item fitted">
                          <label for="graph-enabled" id="graph-enabled-label">Enabled</label>
                        </div>
                        <div class="item">
                          <div class="ui fitted toggle checkbox">
                            <input id="graph-enabled" type="checkbox"${disabled ? '' : ' checked="checked"'}>
                            <label></label>
                          </div>
                        </div>
                        <div class="item">
                          <div class="ui buttons tiny">
                                <button id="graph-publish" class="ui button${currentWorkflowDefinition.version > 0 ? ' disabled' : ''}">Publish</button>
                                <button id="graph-save" class="ui primary button disabled">Save</button>
                                <div class="ui primary dropdown icon button pointing right top compact upward small">
                                    <div class="ui image"><img alt="" class="icon-18 icon-white" src="/images/chevron-down.svg"></div>
                                    <div class="ui menu vertical left compact transition hidden">
                                        <a class="item settings" href="/workflow-definitions/${currentWorkflowDefinition.id}/share-settings" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}">Share settings</a>
                                        <a class="item settings" href="/workflow-definitions/${currentWorkflowDefinition.id}/variables" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}">Variables</a>
                                        <a class="item settings" href="/workflow-definitions/${currentWorkflowDefinition.id}/schedule-trigger" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}">Schedule trigger</a>
                                        <a class="item settings" href="/workflow-definitions/${currentWorkflowDefinition.id}/webhook-settings" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}">Webhook settings</a>
                                        <a class="item settings" href="/workflow-definitions/${currentWorkflowDefinition.id}/workflows${currentWorkflowDefinition.version > 0 ? `?version=${currentWorkflowDefinition.version}` : ''}" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}">Workflows</a>
                                        <div class="divider settings" style="${isEmpty(currentWorkflowDefinition.id) ? ' display: none;' : ''}"></div>
                                        <a id="graph-run" class="item run" href="/workflow-definitions/${currentWorkflowDefinition.id}/start${currentWorkflowDefinition.version > 0 ? `?version=${currentWorkflowDefinition.version}` : ''}" style="${!disabled ? '' : ' display: none;'}">Run</a>
                                        <div id="graph-validate" class="item actionable">Validate</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item"><button id="graph-close" class="ui button">Close</button></div>
                    </div>
                </div>`);

        editorUi.editor.graph.addListener('graphModified', (sender, evt) => {
          if (evt.getProperty('modified') === true) {
            document.getElementById('graph-publish').classList.add('disabled');
            document.getElementById('graph-save').classList.remove('disabled');
          } else {
            document.getElementById('graph-publish').classList.remove('disabled');
            document.getElementById('graph-save').classList.add('disabled');
          }
        });

        document.getElementById("graph-run").addEventListener('click', e => {
          e.preventDefault();
          e.stopImmediatePropagation();
          workflowRun(currentWorkflowDefinition, editorUi.editor.graph.getModel().getRoot().getValue().name);
        });

        document.getElementById("graph-save").addEventListener('click', e => {
            e.preventDefault();
            editorUi.actions.get('save').funct(e);
            editorUi.editor.graph.addListener('graphSavedEvent', () => {
              [
                'publish-wfd-success',
                'publish-wfd-system-error'
              ].forEach(elementId => document.getElementById(elementId).classList.add('hidden'));

              document.querySelectorAll('.page-footer .ui.dropdown .menu .settings').forEach(el => {
                el.style.display = '';

                if (el.href) {
                  const pathname = new URL(el.href).pathname;
                  if (pathname.startsWith('/workflow-definitions//')) {
                    el.href = pathname.replace('/workflow-definitions//', `/workflow-definitions/${currentWorkflowDefinition.id}/`);
                  }
                }
              });

              currentWorkflowDefinition.version = null;

              document.getElementById('graph-run').href = `/workflow-definitions/${currentWorkflowDefinition.id}/start`;
              document.getElementById('graph-publish').classList.remove('disabled');

              $(document.getElementById('workflowDefinitionVersionsDropdown')).dropdown('set selected', '');

              const currentLink = document.getElementById('workflowDefinitionCurrentLink');
              if (currentLink) {
                currentLink.href = `/workflow-definitions/${currentWorkflowDefinition.id}`;
              }
            });
        });

        document.getElementById("graph-publish").addEventListener('click', e => {
          if (!currentWorkflowDefinition.id) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }

          api(`/api/workflow-definitions/${currentWorkflowDefinition.id}/publish`, {
            method: 'PUT'
          }).then(workflowDefinitionIdVersion => {
            if (currentWorkflowDefinition.version === workflowDefinitionIdVersion.version) {
              return;
            }

            document.getElementById('graph-publish').classList.add('disabled');

            [
              'saving-wfd',
              'saving-wfd-error',
              'saving-wfd-system-error',
              'saving-wfd-success',
              'saving-wfd-valid',
              'publish-wfd-system-error'
            ].forEach(elementId => document.getElementById(elementId).classList.add('hidden'));
            document.getElementById('publish-wfd-success').classList.remove('hidden');
            currentWorkflowDefinition.version = workflowDefinitionIdVersion.version;

            const versionsDropdown = document.getElementById('workflowDefinitionVersionsDropdown');
            if (versionsDropdown) {
              if (!versionsDropdown.querySelector(`.item[data-value="${workflowDefinitionIdVersion.version}"]`)) {
                const latestRevisionItem = versionsDropdown.querySelector('.item[data-value=""]');
                latestRevisionItem.insertAdjacentHTML('afterend', `
                <a class="item" data-value="${workflowDefinitionIdVersion.version}" href="/workflow-definitions/${workflowDefinitionIdVersion.id}?version=${workflowDefinitionIdVersion.version}">Version ${workflowDefinitionIdVersion.version}</a>
              `);

                $(versionsDropdown).dropdown('refresh');
              }

              $(versionsDropdown).dropdown('set selected', workflowDefinitionIdVersion.version);

              const currentLink = document.getElementById('workflowDefinitionCurrentLink');
              if (currentLink) {
                currentLink.href = `/workflow-definitions/${currentWorkflowDefinition.id}?version=${currentWorkflowDefinition.version}`;
              }
            }
          }).catch(() => {
            [
              'saving-wfd',
              'saving-wfd-error',
              'saving-wfd-system-error',
              'saving-wfd-success',
              'saving-wfd-valid',
              'publish-wfd-success'
            ].forEach(elementId => document.getElementById(elementId).classList.add('hidden'));
            document.getElementById('publish-wfd-system-error').classList.remove('hidden');
          });
        });

        document.getElementById("graph-enabled").addEventListener('click', e => {
            if (!currentWorkflowDefinition.id) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return;
            }

            const operation = e.target.checked ? 'enable' : 'disable';
            api(`/api/workflow-definitions/${currentWorkflowDefinition.id}/${operation}${currentWorkflowDefinition.version > 0 ? `?version=${currentWorkflowDefinition.version}` : ''}`, {
                method: 'PUT'
            }).then(() => {
              const workflowDefinitionRun = document.getElementById('graph-run');
              if (workflowDefinitionRun) {
                if (operation === 'enable') {
                  workflowDefinitionRun.style.display = '';
                } else {
                  workflowDefinitionRun.style.display = 'none';
                }
              }
            }).catch(() => {
                e.target.checked = !e.target.checked;
            });
        });

        $(document.querySelector('.page-footer .ui.dropdown')).dropdown({
            duration: 0,
            collapseOnActionable: false,
            onActionable: function(value, text, $selected) {
              if ($selected[0].id === 'graph-validate') {
                editorUi.actions.get('validate').funct();
              }
            }
        });
    } else if (closable) {
      target.insertAdjacentHTML('afterend', `
        <div class="ui bottom fixed small borderless menu">
            <div class="right menu">
                <div class="item"><button id="graph-close" class="ui button">Close</button></div>
            </div>
        </div>`);
    }

    const closeButton = document.getElementById("graph-close");
    closeButton && closeButton.addEventListener('click', e => {
        e.preventDefault();
        window.location.replace('/workflow-definitions');
    });
}

const createGraphEditor = target => {
    const templateId = target.getAttribute('data-template-id');
    const workflowId = target.getAttribute('data-wf-id');
    const fullMode = isEmpty(workflowId) && isEmpty(templateId);
    const graphHeight = target.getAttribute('data-height') || '400px';

    const currentWorkflowDefinition = {
      id: target.getAttribute('data-wfd-id'),
      version: Number(target.getAttribute('data-wfd-version')) || null,
      revision: Number(target.getAttribute('data-wfd-revision')) || null
    };

    const graphContainer = document.createElement('div');

    if (!isEmpty(templateId)) {
      graphContainer.className = 'grapheditor-container';
    } else {
      graphContainer.className = 'ui segment grapheditor-container';
    }

    if (!fullMode) {
        graphContainer.style.height = graphHeight;
    }

    target.appendChild(graphContainer);

    const templateWorkflowDefinitionId = templateId || new URLSearchParams(window.location.search).get('template');
    const cloneWorkflowDefinitionId = new URLSearchParams(window.location.search).get('clone');
    const workflowDefinitionId = currentWorkflowDefinition.id || cloneWorkflowDefinitionId || templateWorkflowDefinitionId;
    if (!isEmpty(workflowDefinitionId)) {
        const version = currentWorkflowDefinition.version;
        const revision = currentWorkflowDefinition.revision;

        let input = `/api/workflow-definition-graphs/${workflowDefinitionId}`;
        if (!isEmpty(templateWorkflowDefinitionId)) {
          input = `/api/workflow-definition-templates/${workflowDefinitionId}`;
        } else if (revision > 0) {
          input = `/api/workflow-definition-graphs/${workflowDefinitionId}?revision=${revision}`;
        } else if (version > 0) {
          input = `/api/workflow-definition-graphs/${workflowDefinitionId}?version=${version}`;
        }

        api(input, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        })
            .then(workflowDefinition => {
                let editorUi;

                if (currentWorkflowDefinition.id) {
                    const editable = workflowDefinition.editable && isEmpty(workflowId);
                    editorUi = loadGraphEditor(graphContainer, workflowDefinition.graph || fromWorkflowDefinition(workflowDefinition.workflowDefinition, workflowDefinition.taskProcessors), currentWorkflowDefinition, editable, fullMode);
                    enableButtons(target, editorUi, currentWorkflowDefinition, fullMode, workflowDefinition.disabled);
                } else {
                    editorUi = loadGraphEditor(graphContainer, workflowDefinition.graph || fromWorkflowDefinition(workflowDefinition.workflowDefinition, workflowDefinition.taskProcessors), currentWorkflowDefinition, fullMode, fullMode);
                    enableButtons(target, editorUi, currentWorkflowDefinition, fullMode, true);
                }

                if (!isEmpty(workflowId)) {
                    api(`/api/workflows/${workflowId}/all-tasks`, {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json'
                        }
                    })
                    .then(workflowTasks => {
                        editorUi.editor.graph.overlayWorkflowTasks(workflowTasks);
                        editorUi.actions.get('resetView').funct();
                    });
                }
            })
            .catch(() => enableButtons(target, loadGraphEditor(graphContainer, newWorkflow, currentWorkflowDefinition), currentWorkflowDefinition, fullMode, true));
    } else {
        enableButtons(target, loadGraphEditor(graphContainer, newWorkflow, currentWorkflowDefinition), currentWorkflowDefinition, fullMode, true);
    }
};

document.addEventListener('DOMContentLoaded', () =>
    document.querySelectorAll('div.graph-content[data-template-id],div.graph-content[data-wfd-id]').forEach(el => createGraphEditor(el))
);